import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';

import { BaseConfigureExportModalComponent } from '../_base-configure-export-modal.component';
import { Product } from '../../../../my-products.interface';


@Component({
  moduleId: module.id,
  selector: 'configure-schedule-export-modal',
  templateUrl: 'configure-schedule-export-modal.component.html',
  styleUrls: [
    '../configure-export-modal.component.scss',
    'configure-schedule-export-modal.component.scss'
  ],
})
export class ConfigureScheduleExportModalComponent extends BaseConfigureExportModalComponent implements OnInit {
  nameControl: UntypedFormControl;

  status: string = 'published';

  selectedSchedule: string = '';

  runNow: boolean = false;

  @Input() exportConfigureData: any = {};
  @Input() products: Array<Product> = [];

  scheduleOptions: any = [
    {id: 'daily', label: 'Daily (12:00am EST)'},
    {id: 'weekly', label: 'Weekly (12:00am EST) Sunday'},
    {id: 'monthly', label: 'Monthly (12:00am EST) 15th of the month'},
  ];

  ngOnInit() {
    this.nameControl = new UntypedFormControl('', Validators.compose([
      Validators.pattern('^[^*|:<>?/\]+$'),
    ]));
  }

  onScheduleChange(schedule) {
    this.selectedSchedule = schedule.id;
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get canContinue(): boolean {
    return !!this.selectedSchedule && !!this.nameControl.value;
  }


  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onShow(event: any) {
    this.resetNameControl('');
    this.selectedSchedule = '';
    this.runNow = false;
  }

  onHide(event: any) {
  }

  onCreateScheduleAndRunClick() {
    console.log('Create schedule and run');
    this.runNow = true;
    this.complete.emit(this.getConfigurationData());
  }

  /*******************************************
  * COMPONENT PROTECTED
  *******************************************/

  protected getConfigurationData(): any {
    return _.assign(this.exportConfigureData, {
      schedule: this.selectedSchedule,
      scheduleName: this.nameControl.value,
      runNow: this.runNow
    });
  }

  public resetNameControl(value: string|number = ''): void {
    this.nameControl.reset(value);
  }
}
